import { Component,ElementRef, OnInit,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { ToastrService } from 'ngx-toastr';
import { EnterFocusDirective } from '../directives/enter-focus.directive';
@Component({
  selector: 'app-emponboardingform',
  templateUrl: './emponboardingform.component.html',
  styleUrls: ['./emponboardingform.component.scss']
})
export class EmponboardingformComponent implements OnInit {
  @ViewChild('fullName') fullName!: ElementRef;
  @ViewChild('firstName') firstName!: ElementRef;
 onboardingForm!: FormGroup;
 public add:any= {};
 public departmentdata:any=[];
 public Location:any=[];
  constructor(private fb: FormBuilder,private toastr: ToastrService,public appservice:AppService ,private router: Router) { 
    //  this.onboardingForm = this.fb.group({
    //   accountType: ['Onboarding', Validators.required],
    //   OD_EmployeeID:['', Validators.required],
    //   firstName: ['', Validators.required],
    //   lastName: ['', Validators.required],
    //   fullName: ['', Validators.required],
    //   designation: ['', Validators.required],
    //   grade: ['', Validators.required],
    //   doj: ['', Validators.required],
    //   reporter: ['', Validators.required],
    //   requester: ['', Validators.required]
    // });
  }
  //public string a;
 Onlastenter(){
  
  if(this.add.lastName!='' && this.add.lastName!=undefined){
this.add.fullName=this.add.firstName+' '+this.add.lastName;
  }else{ 
    this.add.fullName=this.add.firstName;
  }
   this.fullName.nativeElement.focus();
  }
  public rec:any=[];
  employeeidcheck(data:any){
     //this.appservice.getTable("Api/Transaction/Getempdetails12?empid="+data).subscribe((res:any)=>{
      this.appservice.getTable("Api/Transaction/Getedit_onboarding?empid="+data).subscribe((res:any)=>{
   if(res!=""){
    this.rec=JSON.parse(res);
   // console.log("the onboarding edit data",this.rec);
  if (this.rec && this.rec.length > 0) {
      let emp = this.rec[0]; // Get first record safely

      // Log first character of first name (if needed)
     
       
      this.add.OD_iid=emp.OD_iid;
      this.add.accountType = emp.OD_Account_type;
      this.add.OD_EmployeeID = emp.OD_EmployeeID;
      this.add.firstName     = emp.OD_First_name;
      this.add.lastName      = emp.OD_Last_Name;
      this.add.fullName = emp.OD_First_name + ' ' + emp.OD_Last_Name;
      this.add.designation   = emp.OD_Designation;
      this.add.grade         = emp.OD_Grad;
      console.log("the date ",emp.OD_Dateofjoin)
      this.add.OD_Dateofjoin = this.appservice.formatCustomDate(emp.OD_Dateofjoin);;
      this.add.Plant         = emp.OD_Plant;
      this.add.Department    = emp.OD_Department;
      this.add.requester     = emp.OD_OnboardingCreatedby;
      this.add.Reporterid=emp.Em_iid;
      this.getstaffdetails(this.add.Reporterid);
      this.add.ReporterMailid =emp.Em_Email;
      console.log("the reporter id",emp.Em_Empcode);
      this.add.Reporterdesignation= emp.Em_Designation;
      this.add.checkerstatus= emp.OD_CheckerStatus;
      this.add.finalapproverstatus= emp.OD_FinalApproverStatus;
      this.appservice.onboardingeditid='';
    } 
    //this.rec=JSON.parse(res);   Em_Empcode
//     this.add.accountType=this.rec[0].
//   this.add.firstName=this.rec[0].Em_First_Name;
//   console.log("the first name",this.rec[0].Em_First_Name);
//   this.add.lastName=this.rec[0].Em_lastName;
//   this.add.fullName=this.rec[0].Em_First_Name+' '+this.rec[0].Em_lastName;
//   this.add.designation=this.rec[0].Em_Designation;
//   this.add.grade=this.rec[0].Em_Grade;
//   this.add.Plant=this.rec[0].Em_Plant;
//   this.add.Department=this.rec[0].Em_Department;
//   this.add.OD_Dateofjoin=this.appservice.formatCustomDate(this.rec[0].Em_DateofJoin);
//  this.fullName.nativeElement.focus();
  }
  
  
     });
//  this.appservice.getTable("Api/Transaction/Getempidstatus?empid="+data).subscribe((res:any)=>{
//    if(res!=""){
//    if(res=="onboardingalready"){
//     this.toastr.warning("The Employee already onboarded");
//     this.add.OD_EmployeeID="";
//    // this.fullName.nativeElement.focus();
//    }
//    else if(res=="offboardingalready"){
//     this.toastr.warning("The Employee already offboarded");
//     this.add.OD_EmployeeID="";
//    }
//   }
//    else{
//     this.fullName.nativeElement.focus();
//     }});
  }
  public tamil:any={}
//   onemployeeenter(data:any){
//     this.appservice.getTable("Api/Transaction/Getempdetails1?empid="+data).subscribe((res:any)=>{
//    if(res!=""){
//     this.tamil=JSON.parse(res);   
//     let ere =this.tamil[0];
//   this.add.firstName=this.tamil[0].Em_First_Name;
//   //console.log("the first name",this.rec[0].Em_First_Name);
//   this.add.lastName=this.tamil[0].Em_lastName;
//   this.add.fullName=this.tamil[0].Em_First_Name+' '+this.rec[0].Em_lastName;
//   this.add.designation=this.tamil[0].Em_Designation;
//   this.add.grade=this.tamil[0].Em_Grade;
//   this.add.Plant=this.tamil[0].Em_Plant;
//   this.add.Department=this.tamil[0].Em_Department;
//   this.add.OD_Dateofjoin=this.appservice.formatCustomDate(this.tamil[0].Em_DateofJoin);
//  this.fullName.nativeElement.focus();}});
//   }
 onemployeeenter(data:any){
    this.appservice.getTable("Api/Transaction/Getempdetails1?empid="+data).subscribe((res:any)=>{
   if(res!=""){
    //  console.log("the  name",res);
    this.tamil=JSON.parse(res);   
     console.log("the first name",this.tamil);
    let ere =this.tamil[0];  
   
  this.add.firstName=ere.Em_First_Name;
  console.log("the first name",ere.Em_First_Name);
  this.add.lastName=ere.Em_lastName;
  this.add.fullName=ere.Em_First_Name+' '+ere.Em_lastName;
  this.add.designation=ere.Em_Designation;
  this.add.grade=ere.Em_Grade;
  this.add.Plant=ere.Em_Plant;
  this.add.Department=ere.Em_Department;
  this.add.Phoneno=ere.Em_PhoneNo
  this.add.OD_Dateofjoin=this.appservice.formatCustomDate(ere.Em_DateofJoin);
 this.fullName.nativeElement.focus();}});
  }
  onSubmit() {
  //event.preventDefault();

   if (this.validateonboarding()) {

    console.log(this.add.OD_EmployeeID);

    const formdate = this.formatToDDMMYYYY(this.add.OD_Dateofjoin);
    this.add.OD_Dateofjoin = formdate;

    console.log("the datas are ", this.add);

    const DATA = this.add;

    this.appservice.postTable("api/Master/Insert_Reference_Values", DATA)
    .subscribe((res:any)=>{

      console.log("API RESPONSE:", res);

      if(res != ""){
        this.toastr.success("The data inserted successfully");
        this.clear();
        this.appservice.goback();
      }

    },
    (err:any)=>{
      console.log(err);
      this.toastr.error("Insert failed");
    });

  } else {

    this.toastr.warning(this.ErrorMessage);

  }
}

public Employeeid:any[]=[];
getstaffid(){
  this.appservice.getTable("Api/Transaction/Getstaffid").subscribe((res:any)=>{
    if (typeof res === 'string') {
  try {
    // Remove control characters before parsing
    const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
    this.Employeeid = JSON.parse(clean);
  } catch (e) {
    console.error("Cleaned JSON parse error:", e);
    this.Employeeid = [];
  }
} else {
  this.Employeeid = res;
}
    //this.Employeeid=JSON.parse(res);
    //console.log("the values",this.Employeeid);
  })
}
formatToDDMMYYYY(dateStr: string): string {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
}
public staffdetails: any = [];
public ErrorMessage:string='';
public plant:any=[];
public Designation:any=[];

validateonboarding(){
  if(this.add.OD_EmployeeID==undefined || this.add.OD_EmployeeID==''){
    this.ErrorMessage="Please Enter Employee ID";
    return false;
  }
  if(this.add.firstName==undefined || this.add.firstName==''){
     this.ErrorMessage="Please Enter First Name";
    return false;
  }
  
  if(this.add.designation==undefined || this.add.designation==''){
     this.ErrorMessage="Please Enter Designation";
    return false;
  }
  if(this.add.grade==undefined || this.add.grade==''){
     this.ErrorMessage="Please Enter Grade";
    return false;
  }
  if(this.add.OD_Dateofjoin==undefined || this.add.OD_Dateofjoin==''){
   this.ErrorMessage="Please Enter Date of Join";
    return false;
 }if(this.add.Plant==undefined || this.add.Plant==''){
     this.ErrorMessage="Please select Plant";
    return false;
 }if(this.add.Department==undefined || this.add.Department==''){
     this.ErrorMessage="Please Enter Department";
    return false;
 }if(this.add.Reporterid==undefined || this.add.Reporterid==''){
     this.ErrorMessage="Please select Reporter ID";
    return false;
 }
 return true;
}
clear(){
  this.add.Reporterid='';
  this.add.Department='';
  this.add.Plant='';
  this.add.OD_Dateofjoin='';
  this.add.grade='';
  this.add.firstName='';
  this.add.designation='';
  this.add.OD_EmployeeID=''
}
onAccountTypeChange() {
    if (this.add.accountType === 'Offboarding') {
      this.type = 'Offboarding';
    } 
    else if(this.add.accountType === 'Role Change') {
      this.type = 'Role Change';
    }else {
      this.type = 'Onboarding';
    }
    this.add= {};
      this.add.requester= this.appservice.RequesterName;
  }
public type:any="Onboarding";
getstaffdetails(data: any) {
  console.log("the id is", data);
  this.appservice.getTable("Api/Transaction/Getstaffdetails?empid=" + data).subscribe((res: any) => {
    if (res != "") {
      this.staffdetails = JSON.parse(res);
      this.add.ReporterName = this.staffdetails[0].Em_First_Name + " " + this.staffdetails[0].Em_lastName;
      this.add.Reporterdesignation = this.staffdetails[0].Em_Designation;
      this.add.ReporterMailid = this.staffdetails[0].Em_Email;
    }
  });
}
GetFurtherstaffDetails(data: any) {
  console.log("the id is", data);
  this.appservice.getTable("Api/Transaction/Getstaffdetails?empid=" + data).subscribe((res: any) => {
    if (res != "") {
      this.staffdetails = JSON.parse(res);
      this.add.FurtherReporterName = this.staffdetails[0].Em_First_Name + " " + this.staffdetails[0].Em_lastName;
      this.add.FurtherReporterdesignation = this.staffdetails[0].Em_Designation;
      this.add.ReporterMailid = this.staffdetails[0].Em_Email;
    }
  });
}

  ngOnInit(): void {
    this.getstaffid();
   this.add.requester= this.appservice.RequesterName;
   //this.add.requester= "K.V.SANKAR GANESH";
    //console.log("the edit id",this.appservice.onboardingeditid);
    this.employeeidcheck(this.appservice.onboardingeditid);
    this.departmentdata=this.appservice.fetchDepartment();
    this.plant=this.appservice.fetchplant();
    //console.log("this plant values are ",this.plant)
    this.Designation=this.appservice.fetchDesignation();
    this.Location=this.appservice.fetchLocation();

  }

}
